import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { VideoFormData } from '../../types/videoPageTypings';
import { videoPayloadFunnelsPageFactory } from '../../utils/videoFunnelsPageFactory';

export function useTryToRequestCreatingVideoFunnelPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: async (payload: VideoFormData) => {
      const factory = await videoPayloadFunnelsPageFactory(payload);
      await apiCancellationFunnels.tryToRequestCreatingVideoFunnelPage(factory);
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao criar o funil de Vídeo',
        'Ocorreu um erro ao criar o funil de Vídeo, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestCreatingVideoFunnelPage: mutateAsync,
    isLoadingCretingVideo: isLoading,
  };
}
